import * as mobx from 'mobx';
import { Provider } from 'mobx-react';
import React from 'react';
import ReactDOM from 'react-dom';
import { ThemeProvider } from 'styled-components';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { RootStore } from './Store';
import { theme } from './Themes';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import { SigninCallback } from './Auth/SigninCallback';
import { SilentRenew } from './Auth/SilentRenew';
import withAuth from './Auth/WithAuth';


const rootStore = new RootStore();

mobx.configure({ enforceActions: 'observed' });

ReactDOM.render(
  <Provider {...rootStore.createStores()}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Switch>
          <Route exact={true} path="/silent-renew" component={SilentRenew} />
          <Route exact={true} path="/signin-callback" component={SigninCallback} />
          <Route path="/" component={withAuth(App)} />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
